"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitcher = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
const Icon_1 = require("../Icon");
require("./index.scss");
const className = 'toggle-switcher';
const ToggleSwitcher = (props) => {
    const { modificators, text, ...restProps } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("label", { className: `${className}__container` },
            react_1.default.createElement("input", { type: 'checkbox', className: `${className}__checkbox`, ...restProps }),
            react_1.default.createElement("span", { className: `${className}__inner` },
                react_1.default.createElement("span", { className: `${className}__icon` },
                    react_1.default.createElement(Icon_1.Icon, { name: 'check-mark' })),
                react_1.default.createElement("span", { className: `${className}__trigger` })),
            react_1.default.createElement("span", { className: `${className}__text` }, text))));
};
exports.ToggleSwitcher = ToggleSwitcher;
//# sourceMappingURL=index.js.map